<script>
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { todoPanelStore } from "../stores";
  import { saveModalStatus } from "./utils";

  export let kind;

  const onclick = async () => {
    $todoPanelStore.status = "done";
    return saveModalStatus();
  };
</script>

<ButtonWithTooltip
  {kind}
  leadingIcon="fa-regular fa-check"
  class="flex-1"
  {onclick}
  size="large"
  placement="top"
>
  <span slot="tooltip"
    >Mark this contact as complete.<br />Campaign steps will continue</span
  >
  Mark as done
</ButtonWithTooltip>
